export const environment = {
  production: true,
  apiBaseUrl:"https://evaluapsi-api.uc.r.appspot.com/api"
  // apiBaseUrl:'http://localhost:3000/api'
};
